import React from 'react';

/**
 * NoDataFound SVG Component
 * 
 * @param {string|number} width - Width of the SVG (default: 206)
 * @param {string|number} height - Height of the SVG (default: 175)
 * @param {string} className - Additional CSS class names
 * @param {object} style - Additional inline styles
 * @param {string} fill - Fill color for the illustration (optional)
 * @param {object} ...props - Additional props passed to the SVG element
 */
const NoDataFoundSvg = ({ 
  width = 206, 
  height = 175, 
  className = '',
  style = {},
  fill,
  ...props 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 206 175" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      {/* Background blob */}
      <g opacity="0.62" filter="url(#filter0_f_5791_40905)">
        <path 
          d="M171.004 145.795C131.215 176.467 100.412 151.309 69.9236 167.067C4.79077 200.732 -35.1461 50.5364 57.643 64.8427C143.299 -18.894 171.004 -8.32275 197.038 41.6991C214.07 74.426 191.22 130.211 171.004 145.795Z" 
          fill={fill || "#E6E6E6"}
        />
      </g>

      {/* Folder structure */}
      <path 
        d="M43.2719 47.1108L48.9887 119.403C63.832 133.216 63.832 121.528 63.832 121.528L123.845 61.6634C125.145 60.3669 125.395 58.352 124.452 56.7768L123.385 54.9941C122.663 53.7874 121.359 53.0488 119.953 53.0488H86.3289C84.8126 53.0488 83.4266 52.1914 82.7496 50.8345L79.8436 45.0097C79.1667 43.6529 77.7807 42.7955 76.2643 42.7955H47.2595C44.926 42.7955 43.088 44.7846 43.2719 47.1108Z" 
        fill="#663C00"
      />

      <path 
        d="M62.0153 63.3443C61.6865 75.9653 60.5907 115.138 59.5911 117.809C58.3982 120.997 51.6393 121.528 49.5183 119.403C48.9508 118.834 48.8388 119.141 48.9791 119.896C49.8597 124.632 54.7736 127.386 59.5911 127.386H141.599C143.663 127.386 145.388 125.815 145.581 123.76L151.222 63.832C151.443 61.4852 149.597 59.4571 147.24 59.4571H127.336H66.0185C63.8469 59.4571 62.0718 61.1735 62.0153 63.3443Z" 
        fill="#BF7000"
      />

      {/* Eyes */}
      <path 
        d="M117.105 79.1821C119.653 79.1821 121.72 81.2528 121.72 83.8091C121.72 86.3652 119.653 88.4351 117.105 88.4351C114.557 88.435 112.49 86.3652 112.49 83.8091C112.49 81.2529 114.557 79.1823 117.105 79.1821Z" 
        fill="white" 
        stroke="white"
      />

      <path 
        d="M94.0853 79.1821C96.6333 79.1821 98.7006 81.2528 98.7006 83.8091C98.7004 86.3652 96.6333 88.4351 94.0853 88.4351C91.5375 88.435 89.4702 86.3652 89.4701 83.8091C89.4701 81.2529 91.5374 79.1823 94.0853 79.1821Z" 
        fill="white" 
        stroke="white"
      />

      {/* Mouth */}
      <path 
        d="M89.5344 109.703C89.704 109.223 90.5417 107.549 91.8959 105.431C93.341 103.17 94.8074 102.339 95.74 101.86C96.6645 101.385 97.8985 101.735 98.9692 102.226C100.067 102.728 100.45 103.609 100.994 104.434C101.903 105.815 102.737 107.25 103.285 107.775C103.891 108.355 104.829 108.533 106.186 108.566C107.255 108.591 108.039 108.087 109.125 107.378C110.238 106.652 110.833 105.458 111.383 104.864C112.011 104.185 112.938 103.444 113.591 102.996C114.367 102.464 115.264 102.376 116.082 102.349C116.978 102.32 117.917 102.965 118.888 103.762C119.826 104.531 120.78 105.688 121.4 106.48C122.112 107.247 122.81 108.025 123.302 108.694C123.419 108.843 123.534 108.972 123.652 109.104" 
        stroke="white" 
        strokeWidth="2" 
        strokeLinecap="round"
      />

      {/* Additional decorative paths */}
      <path 
        d="M7.1264 71.2408C7.07388 71.2408 6.73167 71.4219 6.16226 71.8647C5.57711 72.3198 5.50849 73.4076 5.52034 74.4944C5.52976 75.3591 5.97464 76.0339 6.4427 76.6357C6.92938 77.2615 7.74898 77.5545 8.64974 77.7243C9.6663 77.9158 10.6246 77.7043 11.4 77.323C12.2744 76.8931 12.7864 76.0963 13.1509 75.4865C13.5162 74.8756 13.5186 73.84 13.4136 72.6986C13.328 71.7694 12.6193 71.204 12.0376 70.753C10.5781 70.0858 9.43684 70.0031 8.77511 70.2371C8.45479 70.3936 8.16591 70.6264 7.54994 71.1016" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />

      <path 
        d="M108.481 149.015C108.429 149.015 108.086 149.196 107.517 149.639C106.932 150.094 106.863 151.181 106.875 152.268C106.884 153.133 107.329 153.808 107.797 154.41C108.284 155.035 109.104 155.328 110.004 155.498C111.021 155.69 111.979 155.478 112.755 155.097C113.629 154.667 114.141 153.87 114.506 153.26C114.871 152.649 114.873 151.614 114.768 150.472C114.683 149.543 113.974 148.978 113.392 148.527C111.933 147.86 110.792 147.777 110.13 148.011C109.81 148.167 109.521 148.4 108.905 148.875" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />

      <path 
        d="M135.388 34.4483C136.006 34.8789 136.979 35.6031 138.277 36.5504C140.247 37.9888 141.088 38.6794 141.774 39.4188C141.941 39.5966 142.138 39.7792 142.278 39.9049C142.419 40.0305 142.499 40.0938 142.682 40.2321" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />

      <path 
        d="M135.844 41.4615C136.119 41.1761 136.884 40.3762 137.19 39.9664C137.748 39.2194 138.06 38.5014 138.737 37.5473C139.477 36.5044 139.89 35.8866 140.318 35.304C140.882 34.5363 141.219 34.2111 141.538 33.8665C141.61 33.7865 141.668 33.7209 141.73 33.6577C141.792 33.5944 141.857 33.5354 142.079 33.3356" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />

      {/* Magnifying glass handle */}
      <g filter="url(#filter1_in_5791_40905)">
        <path 
          d="M154.583 135.097L153.378 134.109C152.375 133.287 152.408 131.743 153.445 130.964L155.924 129.1C156.661 128.546 157.681 128.568 158.394 129.152L160.354 130.759L162.212 129.362C162.504 129.143 162.859 129.024 163.224 129.024C163.607 129.024 163.979 129.155 164.278 129.394L164.51 129.58C164.983 129.96 165.259 130.534 165.259 131.141V131.803C165.259 132.421 164.972 133.005 164.483 133.384L155.076 140.669C154.761 140.913 154.347 140.985 153.969 140.861C153.474 140.7 153.14 140.239 153.14 139.72V137.096C153.14 136.394 153.508 135.743 154.109 135.382L154.583 135.097Z" 
          fill="#8C8C8C"
        />
      </g>

      {/* Magnifying glass body */}
      <g filter="url(#filter2_in_5791_40905)">
        <path 
          d="M184.096 150.23L164.231 133.484L156.673 139.375L176.691 157.47C177.938 158.597 179.559 159.221 181.239 159.221H182.346C183.297 159.221 184.214 158.872 184.924 158.239C185.862 157.404 186.337 156.166 186.198 154.918L186.094 153.972C185.932 152.515 185.217 151.175 184.096 150.23Z" 
          fill="#666666"
        />
      </g>

      <path 
        d="M177.133 155.104C176.556 155.008 160.397 140.645 160.108 140.067C159.82 139.489 160.397 139.199 160.974 139.489C161.551 139.778 178.319 152.502 178.608 153.948C178.896 155.393 177.133 155.104 177.133 155.104Z" 
        fill="#D9D9D9"
      />

      {/* Magnifying glass lens */}
      <path 
        d="M138.135 90.5633C151.735 90.5633 164.105 100.338 164.105 113.987C164.105 127.636 151.735 137.41 138.135 137.41C124.535 137.41 112.167 127.636 112.166 113.987C112.166 100.338 124.535 90.5635 138.135 90.5633ZM138.136 94.6121C126.025 94.6121 116.207 102.768 116.206 112.83C116.206 122.892 126.025 131.049 138.136 131.049C150.247 131.048 160.066 122.891 160.066 112.83C160.066 102.768 150.247 94.6123 138.136 94.6121Z" 
        fill="#333333"
      />

      <path 
        d="M138.135 90.5633C151.735 90.5633 164.105 99.8547 164.105 112.83C164.105 125.805 151.735 135.096 138.135 135.096C124.535 135.096 112.166 125.805 112.166 112.83C112.167 99.8548 124.535 90.5635 138.135 90.5633ZM137.943 94.4187C125.831 94.4188 116.013 102.576 116.013 112.637C116.013 122.699 125.832 130.855 137.943 130.855C150.054 130.855 159.872 122.699 159.872 112.637C159.872 102.576 150.054 94.4187 137.943 94.4187Z" 
        fill="#666666"
      />

      {/* Blur effect in magnifying glass */}
      <foreignObject x="76.0133" y="54.419" width="123.859" height="116.437">
        <div 
          xmlns="http://www.w3.org/1999/xhtml" 
          style={{
            backdropFilter: "blur(20px)",
            clipPath: "url(#bgblur_0_5791_40905_clip_path)",
            height: "100%",
            width: "100%"
          }}
        />
      </foreignObject>

      <g opacity="0.5" filter="url(#filter3_i_5791_40905)" data-figma-bg-blur-radius="40">
        <ellipse cx="137.943" cy="112.637" rx="21.9295" ry="18.2183" fill="white" fillOpacity="0.5"/>
      </g>

      <path 
        d="M153.14 139.837V136.904C153.14 136.186 153.888 135.708 154.548 135.991C154.915 136.149 155.159 136.513 155.159 136.912V139.843C155.159 140.508 154.51 140.984 153.872 140.801C153.443 140.678 153.14 140.284 153.14 139.837Z" 
        fill="#666666"
      />

      {/* Filter definitions */}
      <defs>
        <filter id="filter0_f_5791_40905" x="0" y="-7.62939e-05" width="206" height="175" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_5791_40905"/>
        </filter>
        
        <filter id="filter1_in_5791_40905" x="148.646" y="128.699" width="16.6125" height="12.2215" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-4"/>
          <feGaussianBlur stdDeviation="4"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5791_40905"/>
          <feTurbulence type="fractalNoise" baseFrequency="10 10" stitchTiles="stitch" numOctaves="3" result="noise" seed="702" />
          <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA type="discrete" tableValues="0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "/>
          </feComponentTransfer>
          <feComposite operator="in" in2="effect1_innerShadow_5791_40905" in="coloredNoise1" result="noise1Clipped" />
          <feFlood floodColor="rgba(0, 0, 0, 0.2)" result="color1Flood" />
          <feComposite operator="in" in2="noise1Clipped" in="color1Flood" result="color1" />
          <feMerge result="effect2_noise_5791_40905">
            <feMergeNode in="effect1_innerShadow_5791_40905"/>
            <feMergeNode in="color1"/>
          </feMerge>
        </filter>
        
        <filter id="filter2_in_5791_40905" x="152.673" y="133.484" width="37.5246" height="25.7365" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-4"/>
          <feGaussianBlur stdDeviation="4"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5791_40905"/>
          <feTurbulence type="fractalNoise" baseFrequency="10 10" stitchTiles="stitch" numOctaves="3" result="noise" seed="702" />
          <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA type="discrete" tableValues="0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "/>
          </feComponentTransfer>
          <feComposite operator="in" in2="effect1_innerShadow_5791_40905" in="coloredNoise1" result="noise1Clipped" />
          <feFlood floodColor="rgba(0, 0, 0, 0.2)" result="color1Flood" />
          <feComposite operator="in" in2="noise1Clipped" in="color1Flood" result="color1" />
          <feMerge result="effect2_noise_5791_40905">
            <feMergeNode in="effect1_innerShadow_5791_40905"/>
            <feMergeNode in="color1"/>
          </feMerge>
        </filter>
        
        <filter id="filter3_i_5791_40905" x="116.014" y="94.4189" width="43.859" height="36.4365" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="20"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5791_40905"/>
        </filter>
        
        <clipPath id="bgblur_0_5791_40905_clip_path">
          <ellipse cx="137.943" cy="112.637" rx="21.9295" ry="18.2183"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoDataFoundSvg;